var ImageGrid = function () {

    var $html,$body;
    var $imageGrids;

    function init () {
        $html = $('html');
        $body = $('body');
        $imageGrids = $('.image-grid-items');

        registerMediaQueries();
    }

    function registerMediaQueries() {
        enquire.register('screen and (min-width: 768px)', {
            // SM and up
            match : function() {
                setColumns('desktop-grid-template');
            },
            // up to, excluding SM
            unmatch : function() {
                setColumns('mobile-grid-template');
            }
        });
    }

    function setColumns(dataKey) {
        $imageGrids.each(function(i, el) {
            var $el = $(el);
            var columns = $el.data(dataKey);
            $el.css('grid-template-columns', columns)
        })
    }

    return {
        init: init
    }

}();
